<div class="container">
    <div class="content">
        <dl class="header-forms">
            <dt [translate]="'painel-diagnose/city-profile'">
                City Profile
            </dt>
        </dl>
        <div class="cardBox">
            <form class="floating-labels formAboutMore" #f="ngForm" novalidate (ngSubmit)="f.form.valid && onSubmit()">
                <div class="row">
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="cityGrossDomesticProduct" required [(ngModel)]="indicatorForm.cityProfile.cityGrossDomesticProduct" name="cityGrossDomesticProduct" #cityGrossDomesticProduct="ngModel">
                        <div *ngIf="f.submitted && cityGrossDomesticProduct.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="cityGrossDomesticProduct" class="grey01" [translate]="'city-profile/countryGrossDomesticProduct'">City Gross Domestic Product</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="totalPopulation" required [(ngModel)]="indicatorForm.cityProfile.totalPopulation" name="totalPopulation" #totalPopulation="ngModel">
                        <div *ngIf="f.submitted && totalPopulation.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="totalPopulation" class="grey01" [translate]="'city-profile/totalPopulation'">Total Population</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="landArea" required [(ngModel)]="indicatorForm.cityProfile.landArea" name="landArea" #landArea="ngModel">
                        <div *ngIf="f.submitted && landArea.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="landArea" class="grey01" [translate]="'city-profile/landArea'">Land Area</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="populationDensity" required [(ngModel)]="indicatorForm.cityProfile.populationDensity" name="populationDensity" #populationDensity="ngModel">
                        <div *ngIf="f.submitted && populationDensity.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="populationDensity" class="grey01" [translate]="'city-profile/populationDensity'">Population Density </label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="countryGrossDomesticProduct" required [(ngModel)]="indicatorForm.cityProfile.countryGrossDomesticProduct" name="countryGrossDomesticProduct" #countryGrossDomesticProduct="ngModel">
                        <div *ngIf="f.submitted && countryGrossDomesticProduct.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="countryGrossDomesticProduct" class="grey01" [translate]="'city-profile/countryGrossDomesticProduct'">Country Gross Domestic Product </label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="cityGrossOperatingBudget" required [(ngModel)]="indicatorForm.cityProfile.cityGrossOperatingBudget" name="cityGrossOperatingBudget" #cityGrossOperatingBudget="ngModel">
                        <div *ngIf="f.submitted && cityGrossOperatingBudget.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="cityGrossOperatingBudget" class="grey01" [translate]="'city-profile/cityGrossOperatingBudget'">City Gross Operating Budget</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="cityGrossCapitalBudget" required [(ngModel)]="indicatorForm.cityProfile.cityGrossCapitalBudget" name="cityGrossCapitalBudget" #cityGrossCapitalBudget="ngModel">
                        <div *ngIf="f.submitted && cityGrossCapitalBudget.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="cityGrossCapitalBudget" class="grey01" [translate]="'city-profile/cityGrossCapitalBudget'">City Gross Capital Budget</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="percentageOfCountryPopulation" required [(ngModel)]="indicatorForm.cityProfile.percentageOfCountryPopulation" name="percentageOfCountryPopulation" #percentageOfCountryPopulation="ngModel">
                        <div *ngIf="f.submitted && percentageOfCountryPopulation.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="percentageOfCountryPopulation" class="grey01" [translate]="'city-profile/percentageOfCountryPopulation'">Percentage of Country Population</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="percentOfPopulationYouthAged15_24" required [(ngModel)]="indicatorForm.cityProfile.percentOfPopulationYouthAged15_24" name="percentOfPopulationYouthAged15_24" #percentOfPopulationYouthAged15_24="ngModel">
                        <div *ngIf="f.submitted && percentOfPopulationYouthAged15_24.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="percentOfPopulationYouthAged15_24" class="grey01" [translate]="'city-profile/percentOfPopulationYouthAged15_24'">Percent of Population Youth Aged 15 and 24</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="percentOfPopulationSeniorAgedOver65" required [(ngModel)]="indicatorForm.cityProfile.percentOfPopulationSeniorAgedOver65" name="percentOfPopulationSeniorAgedOver65" #percentOfPopulationSeniorAgedOver65="ngModel">
                        <div *ngIf="f.submitted && percentOfPopulationSeniorAgedOver65.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="percentOfPopulationSeniorAgedOver65" class="grey01" [translate]="'city-profile/percentOfPopulationSeniorAgedOver65'">Percent of Population Senior Aged Over 65</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="annualPopulationChange" required [(ngModel)]="indicatorForm.cityProfile.annualPopulationChange" name="annualPopulationChange" #annualPopulationChange="ngModel">
                        <div *ngIf="f.submitted && annualPopulationChange.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="annualPopulationChange" class="grey01" [translate]="'city-profile/annualPopulationChange'">Annual Population Change</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="percentOfPopulationForeignBorn" required [(ngModel)]="indicatorForm.cityProfile.percentOfPopulationForeignBorn" name="percentOfPopulationForeignBorn" #percentOfPopulationForeignBorn="ngModel">
                        <div *ngIf="f.submitted && percentOfPopulationForeignBorn.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="percentOfPopulationForeignBorn" class="grey01" [translate]="'city-profile/percentOfPopulationForeignBorn'">Percent of Population Foreign Born</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="percentOfPopulationNewImmigrants" required [(ngModel)]="indicatorForm.cityProfile.percentOfPopulationNewImmigrants" name="percentOfPopulationNewImmigrants" #percentOfPopulationNewImmigrants="ngModel">
                        <div *ngIf="f.submitted && percentOfPopulationNewImmigrants.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="percentOfPopulationNewImmigrants" class="grey01" [translate]="'city-profile/percentOfPopulationNewImmigrants'">Percent of Population New Immigrants</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="percentOfPopulationChildrenAged0To14" required [(ngModel)]="indicatorForm.cityProfile.percentOfPopulationChildrenAged0To14" name="percentOfPopulationChildrenAged0To14" #percentOfPopulationChildrenAged0To14="ngModel">
                        <div *ngIf="f.submitted && percentOfPopulationChildrenAged0To14.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="percentOfPopulationChildrenAged0To14" class="grey01" [translate]="'city-profile/percentOfPopulationChildrenAged0To14'">Percentage of population that are children (aged 0-14)</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="percentOfPopulationAdultAged25To64" required [(ngModel)]="indicatorForm.cityProfile.percentOfPopulationAdultAged25To64" name="percentOfPopulationAdultAged25To64" #percentOfPopulationAdultAged25To64="ngModel">
                        <div *ngIf="f.submitted && percentOfPopulationAdultAged25To64.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="percentOfPopulationAdultAged25To64" class="grey01" [translate]="'city-profile/percentOfPopulationAdultAged25To64'">Percentage of population that are adults (aged 25-64)</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="maleToFemalRatio" required [(ngModel)]="indicatorForm.cityProfile.maleToFemalRatio" name="maleToFemalRatio" #maleToFemalRatio="ngModel">
                        <div *ngIf="f.submitted && maleToFemalRatio.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="maleToFemalRatio" class="grey01" [translate]="'city-profile/maleToFemalRatio'">Male to Femal Ratio</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="populationDependencyRatio" required [(ngModel)]="indicatorForm.cityProfile.populationDependencyRatio" name="populationDependencyRatio" #populationDependencyRatio="ngModel">
                        <div *ngIf="f.submitted && populationDependencyRatio.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="populationDependencyRatio" class="grey01" [translate]="'city-profile/populationDependencyRatio'">Population Dependency Ratio</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="percentOfPopulationNonCitizens" required [(ngModel)]="indicatorForm.cityProfile.percentOfPopulationNonCitizens" name="percentOfPopulationNonCitizens" #percentOfPopulationNonCitizens="ngModel">
                        <div *ngIf="f.submitted && percentOfPopulationNonCitizens.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="percentOfPopulationNonCitizens" class="grey01" [translate]="'city-profile/percentOfPopulationNonCitizens'">Percent of Population Non Citizens</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="totalNumberOfHouseholds" required [(ngModel)]="indicatorForm.cityProfile.totalNumberOfHouseholds" name="totalNumberOfHouseholds" #totalNumberOfHouseholds="ngModel">
                        <div *ngIf="f.submitted && totalNumberOfHouseholds.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="totalNumberOfHouseholds" class="grey01" [translate]="'city-profile/totalNumberOfHouseholds'">Total Number of Households</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="personsPerUnit" required [(ngModel)]="indicatorForm.cityProfile.personsPerUnit" name="personsPerUnit" #personsPerUnit="ngModel">
                        <div *ngIf="f.submitted && personsPerUnit.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="personsPerUnit" class="grey01" [translate]="'city-profile/personsPerUnit'">Persons Per Unit</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="totalNumberOfOccupiedDwellingUnits" required [(ngModel)]="indicatorForm.cityProfile.totalNumberOfOccupiedDwellingUnits" name="totalNumberOfOccupiedDwellingUnits" #totalNumberOfOccupiedDwellingUnits="ngModel">
                        <div *ngIf="f.submitted && totalNumberOfOccupiedDwellingUnits.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="totalNumberOfOccupiedDwellingUnits" class="grey01" [translate]="'city-profile/totalNumberOfOccupiedDwellingUnits'">total Number of Occupied Dwelling
                            Units</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="dwellingDensity" required [(ngModel)]="indicatorForm.cityProfile.dwellingDensity" name="dwellingDensity" #dwellingDensity="ngModel">
                        <div *ngIf="f.submitted && dwellingDensity.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="dwellingDensity" class="grey01" [translate]="'city-profile/dwellingDensity'">Dwelling Density</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="averageHouseholdIncome" required [(ngModel)]="indicatorForm.cityProfile.averageHouseholdIncome" name="averageHouseholdIncome" #averageHouseholdIncome="ngModel">
                        <div *ngIf="f.submitted && averageHouseholdIncome.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="averageHouseholdIncome" class="grey01" [translate]="'city-profile/averageHouseholdIncome'">Average Household Income</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="cityProductAsPercentOfCountryGDP" required [(ngModel)]="indicatorForm.cityProfile.cityProductAsPercentOfCountryGDP" name="cityProductAsPercentOfCountryGDP" #cityProductAsPercentOfCountryGDP="ngModel">
                        <div *ngIf="f.submitted && cityProductAsPercentOfCountryGDP.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="cityProductAsPercentOfCountryGDP" class="grey01" [translate]="'city-profile/cityProductAsPercentOfCountryGDP'">City Product as Percent of Country GDP</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="employmentAnnualPercentChange" required [(ngModel)]="indicatorForm.cityProfile.employmentAnnualPercentChange" name="employmentAnnualPercentChange" #employmentAnnualPercentChange="ngModel">
                        <div *ngIf="f.submitted && employmentAnnualPercentChange.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="employmentAnnualPercentChange" class="grey01" [translate]="'city-profile/employmentAnnualPercentChange'">Employment Annual Percent Change</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="annualInflationRate" required [(ngModel)]="indicatorForm.cityProfile.annualInflationRate" name="annualInflationRate" #annualInflationRate="ngModel">
                        <div *ngIf="f.submitted && annualInflationRate.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="annualInflationRate" class="grey01" [translate]="'city-profile/annual-inflation'">Annual Inflation Rate</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="giniCoefficient" required [(ngModel)]="indicatorForm.cityProfile.giniCoefficient" name="giniCoefficient" #giniCoefficient="ngModel">
                        <div *ngIf="f.submitted && giniCoefficient.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="giniCoefficient" class="grey01" [translate]="'city-profile/giniCoefficient'">Gini Coefficient</label>
                    </div>
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="countryGDPPerCapita" required [(ngModel)]="indicatorForm.cityProfile.countryGDPPerCapita" name="countryGDPPerCapita" #countryGDPPerCapita="ngModel">
                        <div *ngIf="f.submitted && countryGDPPerCapita.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="countryGDPPerCapita" class="grey01" [translate]="'city-profile/countryGDPPerCapita'">Country GDP PerCapita</label>
                    </div>
                    <!-- <div class="col-lg-12 formInput float-left">
                            <select name="scores"  id="scores" #scores="ngModel" class="form-control" [(ngModel)]="indicatorForm.cityProfile.scores" required>
                                <option *ngFor="let scores of yourProfile" [ngValue]="profile.name">{{scores.scores}}</option>
                            </select>
                        
                        
                            <div *ngIf="f.submitted && scores.invalid" class="invalid-feedback">
                            <div class="info">
                                    <a href="#" data-tooltip="Campo Obrigatório">
                                        <i class="ion ion-md-alert"></i>
                                    </a>
                                </div>
                            </div>
                            <span class="bar"></span>
                            <label for="scores" class="grey01">Scores</label>
                        </div> -->
                    <div class="col-lg-12 formInput">
                        <input type="text" class="form-control" id="generalScore" required [(ngModel)]="indicatorForm.cityProfile.generalScore" name="generalScore" #generalScore="ngModel">
                        <div *ngIf="f.submitted && generalScore.invalid" class="invalid-feedback">
                            <div class="info">
                                <a href="#" data-tooltip="Required">
                                    <i class="ion ion-md-alert"></i>
                                </a>
                            </div>
                        </div>
                        <span class="bar"></span>
                        <label for="generalScore" class="grey01" [translate]="'city-profile/generalScore'">generalScore</label>
                    </div>

                    <div class="col-lg-12 formInput">
                        <button type="submit" [class.btnDisable]="btnDisable" [disabled]="btnDisable" class="btnBranded btnBrandedForm">
                            <app-loading-button *ngIf="btnDisable"></app-loading-button>
                            <span *ngIf="!btnDisable" [translate]="'painel-dashboard/send'">SEND</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>